document.querySelectorAll(".custom__accordion").forEach(btn => {
  const panel = btn.nextElementSibling;

  btn.setAttribute("aria-expanded", "false");
  panel.hidden = true;
  panel.style.maxHeight = "0px";

  btn.addEventListener("click", () => {
    const open = btn.getAttribute("aria-expanded") === "true";

    btn.classList.toggle("active", !open);
    btn.setAttribute("aria-expanded", String(!open));

    panel.hidden = open;
    panel.style.maxHeight = open ? "0px" : panel.scrollHeight + "px";
  });
});
